module.exports = __webpack_public_path__ + "img/crossover_parked.5e207a38.svg";